import { css, Theme } from '@emotion/react'
import { theme } from 'theme/theme'

export const container = (theme: Theme) => css`
  margin: 0 auto;
  max-width: 1142px;
  padding: ${theme.spacing(3)};
`

export const header = (theme: Theme) => css`
  padding: ${theme.spacing(1, 0)};

  font-weight: 700;
`

export const form = () => css`
  display: flex;
  flex-direction: column;
  row-gap: ${theme.spacing(3)};

  margin-top: ${theme.spacing(5)};
`

export const buttonsWrapper = (theme: Theme) => css`
  display: flex;
  align-items: center;
  column-gap: ${theme.spacing(1.25)};

  margin-top: ${theme.spacing(1.25)};
`

export const actionButtonsWrapper = (theme: Theme) => css`
  display: flex;
  column-gap: ${theme.spacing(1.25)};

  margin-left: auto;
`
